import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Input } from '@angular/core';
import { Constants } from '../../../core/constants/constants';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html'
  // styleUrls : ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  @Input() showContent: string;
  @Input() theme: string;
  @Input() showApiDesc: boolean;
  @Input() showApiDocs: boolean;
  @Input() api: any;

  public readonly Constants = Constants;

  constructor(
    private modal:  NgbActiveModal
  ) { }

  ngOnInit() {
  }

  public ok() {
    this.modal.close(true);
  }

  public cancel() {
    this.modal.dismiss(false);
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/confirmation/confirmation.component.ts